import EditIcon from "@mui/icons-material/Edit";
import VerticalAlignCenterIcon from "@mui/icons-material/VerticalAlignCenter";
import { CardContent, Collapse, IconButton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useMemo } from "react";

import { getShowOptions } from "../utils/archiverUtils";
import { HeightAdjustedButton, HeightAdjustedTextField } from "../utils/StyledComponents";

import CandidateCardHeader from "./CandidateCardHeader";
import SelectForm from "./SelectForm";

export default function CandidateSeriesRoot({
  candidateRoot,
  shows,
  actionTypes,
  candidateTypes,
  onHide,
  onRootActionIconClick,
  onRootSelectOptionChange,
  onCandidateRootUpdate,
  handleRootEditClick,
  onCandidateRootTextFieldChange,
  onCandidateRootTypeOptionChange,
}) {
  const isEditOpen = useMemo(() => candidateRoot.isEditState ?? false, [candidateRoot.isEditState]);

  return (
    <CardContent style={{ paddingBottom: 0 }}>
      <Grid container spacing={1} justifyContent="space-between" alignItems="center">
        <CandidateCardHeader
          candidateRoot={candidateRoot}
          actionTypes={actionTypes}
          candidateTypes={candidateTypes}
          onHide={onHide}
          onRootActionIconClick={onRootActionIconClick}
          onCandidateRootTypeOptionChange={onCandidateRootTypeOptionChange}
        />

        <Grid size={{ xs: 2, md: 1 }}>
          <IconButton name={candidateRoot.path} onClick={handleRootEditClick}>
            {isEditOpen ? <VerticalAlignCenterIcon /> : <EditIcon />}
          </IconButton>
        </Grid>

        <Grid size={{ xs: 10, md: 11 }}>
          <Typography
            variant="body1"
            color="textSecondary"
            component="p"
            style={{ overflowWrap: "break-word" }}
          >
            {candidateRoot.path.substring(candidateRoot.mediaRootPath.length)}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Collapse in={isEditOpen} timeout="auto" unmountOnExit>
            <Grid container spacing={2} justifyContent="space-between">
              <Grid size={{ xs: 12, md: 5 }}>
                <SelectForm
                  name={candidateRoot.path}
                  id="seriesId"
                  value={candidateRoot.seriesId ?? 0}
                  onChange={onRootSelectOptionChange}
                  label="Series"
                  options={getShowOptions(shows)}
                />
              </Grid>

              <Grid size={{ xs: 3, md: 2 }}>
                <HeightAdjustedTextField
                  value={candidateRoot.seasonNumber ?? ""}
                  onChange={onCandidateRootTextFieldChange}
                  id="seasonNumber"
                  name={candidateRoot.path}
                  type="number"
                  label="Season"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid size={{ xs: 4, md: 2 }} />

              <Grid size={{ xs: 5, md: 3 }}>
                <HeightAdjustedButton
                  variant="contained"
                  onClick={onCandidateRootUpdate}
                  color="primary"
                  size="large"
                  name={candidateRoot.path}
                  fullWidth
                >
                  Update all
                </HeightAdjustedButton>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Grid>
    </CardContent>
  );
}
